<template>
    <div class="salesInvoice">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目部：">
                                <el-select v-model="dataForm.projectDeptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="欠款单位：">
                                <el-input v-model="dataForm.debtName" placeholder="请输入欠款单位" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <div v-if="showAdvanceFilter">
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="发票抬头：">
                                    <el-input v-model="dataForm.billHead" placeholder="请输入发票抬头" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="100px" label="纳税人识别号：">
                                    <el-input v-model="dataForm.billTaxNumber" placeholder="请输入纳税人识别号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="申请日期：">
                                    <el-date-picker
                                            v-model="dataForm.approveTime"
                                            @change="approveTimeChange"
                                            type="daterange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            :default-time="['00:00:00', '23:59:59']">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="不含税金额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.notTaxPriceMin" placeholder="请输入最小不含税金额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.notTaxPriceMax" placeholder="请输入最大不含税金额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="税额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.taxPriceMin" placeholder="请输入最小税额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.taxPriceMax" placeholder="请输入最大税额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="发票金额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.priceMin" placeholder="请输入最小发票金额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.priceMax" placeholder="请输入最大发票金额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="税率：">
                                    <el-input v-model="dataForm.taxRatio" placeholder="请输入税率" clearable></el-input>
                                </el-form-item>
                            </el-col>
<!--                            <el-col :span="6">-->
<!--                                <el-form-item label-width="80px" label="发票金额：">-->
<!--                                    <el-input v-model="dataForm.price" placeholder="请输入发票金额" clearable></el-input>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="审批状态：">
                                    <el-select v-model="dataForm.approveStatus" placeholder="请选择审批状态">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="已保存" value="0"></el-option>
                                        <el-option label="待审批" value="2"></el-option>
                                        <el-option label="已通过" value="3"></el-option>
                                        <el-option label="已拒绝" value="4"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </div>
                        <el-col :span="6" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.addBtn.btnEnable"
                                    type="primary"
                                    icon="el-icon-plus"
                                    @click="goToSalesApply()"
                            >发起申请</el-button>
<!--                            <el-button-->
<!--                                    v-if="btnAuthorize.approve.btnEnable"-->
<!--                                    type="primary"-->
<!--                                    icon="el-icon-check"-->
<!--                                    @click="approveContract()"-->
<!--                            >提交审批</el-button>-->
                            <el-button
                                    v-if="btnAuthorize.modifyBtn.btnEnable"
                                    type="primary"
                                    icon="el-icon-upload2"
                                    @click="goToSalesInput()"
                            >发票录入</el-button>
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportHandle()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="invoiceList"
                        highlight-current-row
                        @selection-change="handleSelectionChange"
                        @row-click="rowClicked"
                        @cell-dblclick="dblclickDetail"
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column
                            prop="approveCode"
                            label="申请编号"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectDeptName"
                            label="项目部"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="debtName"
                            label="欠款单位"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billHead"
                            label="发票抬头"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billTaxNumber"
                            label="纳税人识别号"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120"
                            prop="notTaxPrice"
                            label="不含税金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="taxPrice"
                            label="税额（元）"
                            width="90"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="categoryDisplayName"
                        label="发票类型"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="typeDisplayName"
                        label="发票种类"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="taxRatio"
                            label="税率（%）"
                            width="90"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="price"
                            label="发票金额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="approveUserName"
                            label="申请人"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="approveTime"
                            label="申请日期"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="approveStatusDisplayName"
                            label="审批状态"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>


        <!-- 审批弹框 -->
        <el-dialog
                title="项目审批"
                :visible.sync="approvedialogVisible"
                width="30%"
                :before-close="handleClose"
                :close-on-click-modal="false"
        >
            <el-form :model="Approveform" label-width="70px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="申请编号">
                            <el-input v-model="Approveform.approveCode" :readonly="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="项目名称">
                            <el-input v-model="Approveform.projectName" autocomplete="off" :readonly="true"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="审批意见">
                            <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="Approveform.opinion"
                                    maxlength="266"
                                    size="medium"
                                    style="width: 100%;min-width: 266px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="confirmsubContract(4)">驳 回</el-button>
                <el-button type="primary" @click="confirmsubContract(3)">审批通过</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getSalesInvoiceService,
        getDeptListService,
        getProjectListService,
        queryCurrentApproveProcessService,
        submitApproveProcessService,
        approveExportService,
    } from '@/services/invoiceServices'
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "salesInvoice",
        data(){
            return {
                dataForm:{
                    projectDeptId:'',
                    projectId:'',
                    debtName:'',
                    billHead:'',
                    billTaxNumber:'',
                    approveTime: '',
                    approveStartTime:'',
                    approveEndTime:'',
                    notTaxPriceMin:'',
                    notTaxPriceMax:'',
                    taxPriceMin:'',
                    taxPriceMax:'',
                    taxRatio:'',
                    priceMin:'',
                    priceMax:'',
                    approveStatus:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total:0,
                showAdvanceFilter: false,

                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[], //表格数据列表
                selectItems:[], //选中的列表

                approvedialogVisible: false,
                //审批对话框form
                Approveform: {
                    approveCode: "",
                    projectName: "",
                    itemId: "", //项目经理id
                    approveUserId: "", //审批人id
                    deptId: "", //部门id
                    opinion: "" //审批意见
                },
                btnAuthorize: {
                    addBtn: { key: "create", btnEnable: false },
                    approve: { key: "approve", btnEnable: false }, //审核
                    modifyBtn: { key: "update", btnEnable: false },
                    export: { key: "export", btnEnable: false }
                },
            }
        },
        props: {
            menuCode: {
                type: String
            }
        },
        methods:{
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getInvoiceList();
                this.getDeptList();
            },
            //根据条件查询
            query(){
                this.getInvoiceList();
            },
            //重置数据
            reset(){
                this.dataForm = {
                    projectDeptId:'',
                    projectId:'',
                    debtName:'',
                    billHead:'',
                    billTaxNumber:'',
                    approveTime: '',
                    approveStartTime:'',
                    approveEndTime:'',
                    notTaxPriceMin:'',
                    notTaxPriceMax:'',
                    taxPriceMin:'',
                    taxPriceMax:'',
                    taxRatio:'',
                    priceMin:'',
                    priceMax:'',
                    approveStatus:'',
                    pageIndex: 1,
                    pageSize: 10,
                };
                this.projectList = [];
                this.getInvoiceList();
            },
            /**
             * 获取列表数据
             * */
            getInvoiceList(){
                let paramsData = {
                    ...this.dataForm
                }
                getSalesInvoiceService(paramsData).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.invoiceList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.projectDeptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },

            //跳转到审批对话框
            approveContract() {
                if (this.selectItems.length === 1) {
                    if (this.selectItems[0].approveStatusDisplayName == '已拒绝') {

                      this.getApproveList(this.selectItems[0].id);

                    }else {
                      this.$alert("该销项发票不能提交审批！", "提示", {
                        confirmButtonText: "确定"
                      });
                      return;
                    }
                } else {
                    this.$alert("请选择一条发票信息", "提示", {
                        confirmButtonText: "确定"
                    });
                }
            },
            //查询当前审批流
            getApproveList(id) {
                let param = {
                    id: id,
                    approveUserId: sessionStorage.getItem("currentUserId"),
                    type:'OUTPUT'
                };
                queryCurrentApproveProcessService(param)
                    .then(res => {
                        if (res.code == 10000000) {
                            this.approvedialogVisible = true;
                            this.Approveform = { ...res.data };
                            this.Approveform.approveCode = this.selectItems[0].approveCode;
                            this.Approveform.projectName = this.selectItems[0].projectName;
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    })
                    .catch(error => {});
            },
            //确认审批
            confirmsubContract(val) {
                let param = this.Approveform;
                param.status = val; //3：通过 4：驳回
                param.type = 'OUTPUT'; // 状态 销项发票标识
                if (null == param.opinion || param.opinion == "") {
                    this.$alert("请填写审批备注", "提示", {
                        confirmButtonText: "确定"
                    });
                    return;
                }
                this.$confirm(val == 3?"确认审批该销项发票吗？":"确认驳回该销项发票吗？", "提示", {
                    confirmButtonText: "确认"
                }).then(() => {
                    submitApproveProcessService(param).then(res => {
                        if (res.code == "10000000") {
                            this.$alert(val == 3?"审批成功":"驳回成功", "提示", {
                                confirmButtonText: "确定"
                            });
                            this.query();
                            this.approvedialogVisible = false;
                        } else if (res.code > 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$message.error("系统异常");
                        }
                    })
                    .catch(error => {
                        this.$message.error("系统异常");
                    });
                });
            },
            approveTimeChange(val){
                if(val){
                    this.dataForm.approveStartTime = this.dataForm.approveTime[0];
                    this.dataForm.approveEndTime = this.dataForm.approveTime[1];
                }else{
                    this.dataForm.approveStartTime = '';
                    this.dataForm.approveEndTime = '';
                }
            },
            //审批关闭
            handleClose(done) {
                this.$confirm("确认关闭？",'提示')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            // 高级搜索按钮
            moreScreen() {
                this.showAdvanceFilter = !this.showAdvanceFilter;
            },
            // 列代表多选回调
            handleSelectionChange(val) {
                this.selectItems = val;
            },
            // 点击选中行
            rowClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
            },
            dblclickDetail(row, column, cell, event) {
                this.bus.$emit("navMenuChange", {
                    routeId: "salesInvoiceDetail",
                    routeParam: {
                        approveId: row.id
                    }
                });
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
            //跳转发起申请
            goToSalesApply(){
                this.bus.$emit("navMenuChange", {
                    routeId: "salesApply",
                    routeParam: {

                    }
                });
            },
            //跳转发票录入
            goToSalesInput(){
                if (this.selectItems.length === 1) {
                    if (this.selectItems[0].approveStatusDisplayName != '已通过') {
                        this.$alert("该销项发票不能录入", "提示", {
                            confirmButtonText: "确定"
                        });
                        return;
                    }
                    this.bus.$emit("navMenuChange", {
                        routeId: "salesInput",
                        routeParam: {
                            approveId: this.selectItems[0].id
                        }
                    });
                } else {
                    this.$alert("请选择一条发票信息", "提示", {
                        confirmButtonText: "确定"
                    });
                }

            },
            /**
             * 导出
             * */
            exportHandle(){
                let params = {
                    ...this.dataForm,
                    pageSize: 10000,
                }
                approveExportService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .salesInvoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    /deep/.el-form-item__content{
        height: 40px;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
        /deep/.el-form-item__content{
            height: auto;
        }
    }
    .fixStyle{
        display: flex;
        align-items: center;
        .lineBox{
            margin: 0 10px;
        }
    }
</style>
